import React, { useState } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { useLocation } from "react-router-dom";

const DealerReviewForm = () => {
  const [driver, setdriver] = useState(0);
  const [professionalism, setProfessionalism] = useState(0);
  const [communication, setCommunication] = useState(0);
  const [rating, setrating] = useState(0);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const location = useLocation();
  const { jobId, customercompanyname } = location.state || {}; // Default empty object to avoid errors
  const token = sessionStorage.getItem("authTokenDealer");
     
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const formData = {
        Name: data.reviewPerson,
        jobId:jobId,
        feedback: data.reviewContent,
        driver,
        professionalism,
        communication,
        rating,
      };

      setLoading(true);
      const response = await axios.post(
        'https://zoomautos.co.uk/api/movereviews',
        formData
      );

      if (response.status === 201) {
        setLoading(false);
        setSuccess(true);
        console.log('Review submitted successfully:', response.data);
        window.location.reload();
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      alert('There was an error submitting your review. Please try again.');
    }
  };

  const renderStars = (rating, setRating) => (
    <div className="rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          onClick={() => setRating(star)}
          style={{ cursor: 'pointer', color: star <= rating ? '#e80f17' : 'gray' }}
        >
          ★
        </span>
      ))}
    </div>
  );

  return (
    <div style={{marginTop:'100px'}}>
    
    <img
                            src="/TC.png"
                            alt="Logistics Background"
                            className="background-image"
                          />
    <div className="review-form">
      <h2 style={{ color: '#01103b' }}>Write A Review</h2>
      <label> <strong>JOB ID: </strong>{jobId}</label>
      <form onSubmit={handleSubmit(onSubmit)}>
        
        <label htmlFor="reviewPerson">Your Name</label>
        <input
          type="text"
          id="reviewPerson"
value={customercompanyname}
        />
        {errors.reviewPerson && <p className="error-message">{errors.reviewPerson.message}</p>}

        <label htmlFor="reviewContent">Description</label>
        <textarea
          placeholder="Tip: Ideal length for a good review is 200 to 350 words. Use minimum 50 words."
          rows="5"
          {...register('reviewContent', {
            required: 'Review content is required',
            minLength: { value: 50, message: 'Review must be at least 50 words' },
          })}
        />
        {errors.reviewContent && <p className="error-message">{errors.reviewContent.message}</p>}

        <label>Driver</label>
        {renderStars(driver, setdriver)}

        <label>Professionalism</label>
        {renderStars(professionalism, setProfessionalism)}

        <label>Communication</label>
        {renderStars(communication, setCommunication)}

        <label>Overall Rating</label>
        {renderStars(rating, setrating)}

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button type="submit" className="contact-button">Submit</button>
        </div>
      </form>

      {loading && <div className='overlayStyle'><div className='loadingStyle'>Submitting...</div></div>}

      {success && <div className='overlayStyle'><div className='successStyle'>Thanks for Submitting your Review! It means a lot to us!</div></div>}
    </div>
    </div>
  );
};

export default DealerReviewForm;
